import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/api';
import supabase from '../../utils/supabase';
import styles from '../../styles/ManageAgency.module.css';
import buttonStyles from '../../styles/Buttons.module.css';

const AdminLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      // Sign in with Supabase client first
      const { data, error } = await supabase.auth.signInWithPassword({ email, password });
      if (error || !data?.session?.access_token) {
        const errMsg = error?.message || 'Supabase sign-in failed';
        throw new Error(errMsg);
      }
      const accessToken = data.session.access_token;

      // Verify admin via backend
      const res = await axios.post(
        `${API_BASE_URL}/api/admin/login`,
        {},
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      const token = res.data?.token || accessToken;
      if (token) {
        sessionStorage.setItem('adminToken', token);
        window.location.href = '/admin';
      } else {
        setError('Login failed');
      }
    } catch (err: any) {
      console.error('Admin login error', err);
      const message = err?.response?.data?.message || err?.message || 'Login error';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.inviteForm} style={{maxWidth:480, margin:'40px auto'}}>
      <h2>Super Admin Login</h2>
      <form onSubmit={handleSubmit} style={{ maxWidth: 420 }}>
        <div className={styles.formRow}>
          <label htmlFor="admin-email" className={styles.formRowLabel}>Email</label>
          <input id="admin-email" className={styles.formRowInput} type="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </div>
        <div className={styles.formRow} style={{ marginTop: 12 }}>
          <label htmlFor="admin-password" className={styles.formRowLabel}>Password</label>
          <input id="admin-password" className={styles.formRowInput} type="password" value={password} onChange={e => setPassword(e.target.value)} required />
        </div>
        {error && <div style={{color:'red'}}>{error}</div>}
        <div className={styles.inviteActions}>
          <button type="submit" disabled={loading} className={`${buttonStyles.button} ${buttonStyles.formPrimary}`}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
